import React from 'react';
import { sumMapsAcrossDays } from './aggregations';

export default function PayerMix({ dailyDocs = [] }) {
    const agg = sumMapsAcrossDays(dailyDocs, 'by_insurance_provider');
    const entries = Object.entries(agg).sort(([, a], [, b]) => b - a);
    if (entries.length === 0) {
        return (
            <section className="dashboard-section">
                <h3>Payer mix (30d)</h3>
                <p className="dashboard-empty">No data yet.</p>
            </section>
        );
    }
    const max = Math.max(1, ...entries.map(([, n]) => n));
    return (
        <section className="dashboard-section">
            <h3>Payer mix (30d)</h3>
            <div className="dashboard-bar-list">
                {entries.map(([k, n]) => (
                    <div key={k} className="dashboard-bar">
                        <div className="dashboard-bar-fill" style={{ width: `${(n / max) * 100}%` }} />
                        <span className="dashboard-bar-label">{k} · {n}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
